<div class="modal-header">
  <h4 class="modal-title">{{ 'MODAL.CHANGE_PASSWORD.TITLE' | translate }}</h4>
  <i aria-label="Close" (click)="handleClick()" class="close pull-right align-middle fas fa-times"> </i>
</div>

<div class="modal-body">
  <form name="form" role="form" [formGroup]="passwordForm">
    <jhi-bary-input-password
      [label]="'MODAL.CHANGE_PASSWORD.FORM.CURRENT_PASS.LABEL' | translate"
      [control]="passwordForm.controls['currentPassword'] | asFormControl"
    ></jhi-bary-input-password>

    <jhi-bary-input-password [label]="'LABEL.NEW_PASSWORD' | translate" [control]="passwordForm.controls['newPassword'] | asFormControl"></jhi-bary-input-password>

    <jhi-password-strength-bar [passwordToCheck]="passwordForm.controls['newPassword']!.value!"></jhi-password-strength-bar>

    <jhi-bary-input-password [label]="'LABEL.CONFIRM_PASSWORD' | translate" [control]="passwordForm.controls['confirmPassword'] | asFormControl"></jhi-bary-input-password>

    <div class="text-danger text-center" *ngIf="passwordForm.errors?.['passwordMismatch'] && (passwordForm.dirty || passwordForm.touched)">
      <small>{{ 'MODAL.CHANGE_PASSWORD.FORM.ERROR.PASSWORD_MIS_MATCH' | translate }}</small>
    </div>
  </form>
</div>

<div class="modal-footer justify-content-center">
  <jhi-bary-button [outline]="true" color="primary" [label]="'BTN.CANCEL' | translate" (clickEvent)="handleClick()" class="mr-2"></jhi-bary-button>
  <jhi-bary-button
    (clickEvent)="handleSubmit()"
    [disabled]="passwordForm.invalid"
    [label]="'BTN.CONFIRM' | translate"
    data-id-cypress="confirm-update"
    color="primary"
  ></jhi-bary-button>
</div>
